import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-gauge",
  templateUrl: "./gauge.component.html",
  styleUrls: ["./gauge.component.css"],
})
export class GaugeComponent implements OnInit, OnChanges {
  @Input() percentage: number = 0;
  @Input() maxWidth: string = "200px"; // Opcional
  indicadorVermelho = "#e00101ff";
  indicadorAmarelo = "#e0dc01ff";
  indicadorVerde = "#09af1fff";
  indicadorAzul = "#012ae0ff";

  needleRotation: number = 0;

  constructor() {}

  ngOnInit() {   
    this.needleRotation = (this.percentage / 100) * 180 - 90;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['percentage']) {      
      this.needleRotation = (this.percentage / 100) * 180 - 90;
    }
  }
}
